<p-toast />
<p-toast position="top-center" key="auth-message"> </p-toast>
@if (isReady) {
    <router-outlet />

    <p-confirmDialog appendTo="body"></p-confirmDialog>
    <p-confirmDialog appendTo="body" key="deletion-confirm" acceptButtonStyleClass="p-button-danger"></p-confirmDialog>
} @else if (error) {
    <p-card [style]="{width: '30rem', margin: 'auto', 'text-align': 'center'}">
        <h2>Failed to initialize the application</h2>
    </p-card>
} @else {
    <p-card [style]="{width: '30rem', margin: 'auto', 'text-align': 'center'}">
        <p-progress-spinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progress-spinner>
        <div class="mt-2 mb-2">Loading</div>
    </p-card>
}
